import React, { Dispatch, ReactElement, ReactNode, SetStateAction } from 'react';
import { CheckboxValueType } from 'antd/es/checkbox/Group';
import { ColumnsType } from 'antd/es/table';
import { Checkbox } from 'common/components/antd/Checkbox/Checkbox';
import { Popover } from 'common/components/antd/Popover/Popover';
import { SCheckboxGroup } from './ColumnSettingsPopover.style';

type PopoverContentProps<RecordType extends object = any> = {
  visibleColumnIndexes: CheckboxValueType[];
  columns: ColumnsType<RecordType>;
  setVisibleColumnIndexes: Dispatch<SetStateAction<CheckboxValueType[]>>;
};

const PopoverContent = <RecordType extends object = any>({
  visibleColumnIndexes,
  columns,
  setVisibleColumnIndexes,
}: PopoverContentProps<RecordType>): ReactElement => (
  <SCheckboxGroup
    value={visibleColumnIndexes}
    onChange={(checkedValues: CheckboxValueType[]): void => {
      setVisibleColumnIndexes(checkedValues);
    }}
  >
    {columns.map((column, index) => (
      <div key={column.key}>
        <Checkbox checked value={index}>
          <span>{(column?.title || column?.key) as string}</span>
        </Checkbox>
      </div>
    ))}
  </SCheckboxGroup>
);

type ColumnSettingsPopoverProps<RecordType extends object = any> = {
  columns: ColumnsType<RecordType>;
  visibleColumnIndexes: CheckboxValueType[];
  setVisibleColumnIndexes: Dispatch<SetStateAction<CheckboxValueType[]>>;
  children: ReactNode;
};

const ColumnSettingsPopover = <RecordType extends object = any>({
  columns,
  visibleColumnIndexes,
  setVisibleColumnIndexes,
  children,
}: ColumnSettingsPopoverProps<RecordType>): ReactElement => (
  <Popover
    placement="bottomRight"
    arrow={false}
    trigger="click"
    content={
      <PopoverContent
        setVisibleColumnIndexes={setVisibleColumnIndexes}
        visibleColumnIndexes={visibleColumnIndexes}
        columns={columns}
      />
    }
  >
    {children}
  </Popover>
);

export { ColumnSettingsPopover };
